module.exports = "../images/rates-cad@2x.jpg?v=cefc98c";